module.exports = __webpack_public_path__ + "static/media/Krisli.31245a04.jpg";